import { render, staticRenderFns } from "./CopyDetail.vue?vue&type=template&id=0442c6a7&scoped=true"
import script from "./CopyDetail.vue?vue&type=script&lang=js"
export * from "./CopyDetail.vue?vue&type=script&lang=js"
import style0 from "./CopyDetail.vue?vue&type=style&index=0&id=0442c6a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0442c6a7",
  null
  
)

export default component.exports